import { Article } from '@/constants';
import { createContext } from 'react';

export const ArticleContext = createContext<ArticleContextProps>({
	article: undefined,
	language: 'en',
	fontSize: 62.5,
	setFontSize: () => {},
	toggleMenu: () => {},
});

interface ArticleContextProps {
	article?: Article;
	language: string;
	fontSize: number;
	setFontSize: (size: number) => void;
	toggleMenu: Function;
}
